export const SaleSourceFilter = ({
  saleSources,
  selectedSaleSource,
  onSaleSourceChange,
}) => {
  if (!saleSources.length) {
    return null;
  }

  return (
    <div className="sale-source-tabs">
      {saleSources.map(
        ({ saleSource, count }) => {
          const isSelected =
            selectedSaleSource === saleSource;

          return (
            <button
              key={saleSource}
              type="button"
              className={`sale-source-tab ${
                isSelected
                  ? "sale-source-tab-active"
                  : ""
              }`}
              onClick={() =>
                onSaleSourceChange(
                  isSelected ? "" : saleSource
                )
              }
            >
              {saleSource} <span>{count}</span>
            </button>
          );
        }
      )}
    </div>
  );
};